var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranslateOriginal1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 108H85.3225L76.7925 94.16H66C61.0375 94.16 57 90.1225 57 85.16V58.16C57 53.1975 61.0375 49.16 66 49.16H99C103.963 49.16 108 53.1975 108 58.16V85.16C108 90.1225 103.963 94.16 99 94.16H93V108ZM66 55.16C64.345 55.16 63 56.505 63 58.16V85.16C63 86.815 64.345 88.16 66 88.16H80.1425L87 99.2875V88.16H99C100.655 88.16 102 86.815 102 85.16V58.16C102 56.505 100.655 55.16 99 55.16H66Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 15H21C17.6875 15 15 17.6875 15 21V48C15 51.3125 17.6875 54 21 54H27L36 69H39V54H48C48 47.3725 53.3725 42 60 42V21C60 17.6875 57.3125 15 54 15Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 72H34.3025L25.3025 57H21C16.0375 57 12 52.9625 12 48V21C12 16.0375 16.0375 12 21 12H54C58.9625 12 63 16.0375 63 21V45H60C55.0375 45 51 49.0375 51 54V57H42V72ZM21 18C19.345 18 18 19.345 18 21V48C18 49.655 19.345 51 21 51H28.6975L36 63.17V51H45.3025C46.4975 45.1325 51.1325 40.4975 57 39.3025V21C57 19.345 55.655 18 54 18H21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateOriginal1);
export default __webpack_public_path__ + "static/media/Translate_Original_1.32bb0094.svg";
export { ForwardRef as ReactComponent };